module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/arrow2-b587d5c448e13695a942c4afdb499fc9.svg";